import { jsx as _jsx } from "react/jsx-runtime";
import ReceptionDesks from 'pages/ReceptionDesks';
import { Route } from 'react-router';
import AuthorizationService from 'routes/AuthorizationService';
import { Index } from 'constants/actions';
import { ReceptionDesk as ReceptionDeskResource } from 'constants/resources';
var ReceptionDeskRoutes = function () {
    return ([
        _jsx(Route, { caseSensitive: true, path: '/reception_desks', element: AuthorizationService.getAuthorizedElement(_jsx(ReceptionDesks, {}), Index, ReceptionDeskResource) }, 'reception-desks-route')
    ]);
};
export default ReceptionDeskRoutes;
